import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getToken, requestErrorHandler } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import Title from "./Title";
const server = EnvSettings.server;

export default function EmailSubscriptionList({ resource }) {
  const { t } = useTranslation();
  const [subscribers, setSubscirbers] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    const getSubscribers = (resource) => {
      if (!resource) {
        return;
      }
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          resource: resource,
        }),
      };
      fetch(server + "/get_email_subscribers", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          requestErrorHandler(result, dispatch);
          if (!result.error) {
            setSubscirbers(result.subscribers);
          }
        });
    };
    getSubscribers(resource);
  }, [resource, setSubscirbers, dispatch]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Title>{t("emailSubscriptionList.header")}</Title>
      </Grid>
      <Grid item xs={12}>
        {subscribers && subscribers.length
          ? subscribers.map((s) => <Typography>{s?.name || s}</Typography>)
          : null}
      </Grid>
    </Grid>
  );
}
